import type { CSSProperties, FC, ReactNode } from 'react';

export type SeverityPillColor = 'primary' | 'secondary' | 'error' | 'info' | 'warning' | 'success';

interface SeverityPillProps {
  children?: ReactNode;
  color?: SeverityPillColor;
  style?: CSSProperties;
  className?: string;
}

const colorClassMap: Record<SeverityPillColor, string> = {
  primary: 'tw:bg-fuul-blue/12 tw:text-fuul-blue tw:dark:bg-fuul-blue/20 tw:dark:text-fuul-blue',
  secondary: 'tw:bg-info-alpha12 tw:text-info-dark tw:dark:bg-info-alpha12 tw:dark:text-info-light',
  error: 'tw:bg-error-alpha12 tw:text-error-dark tw:dark:bg-error-alpha12 tw:dark:text-error-light',
  info: 'tw:bg-info-alpha12 tw:text-info-dark tw:dark:bg-info-alpha12 tw:dark:text-info-light',
  warning: 'tw:bg-warning-alpha12 tw:text-warning-dark tw:dark:bg-warning-alpha12 tw:dark:text-warning-light',
  success: 'tw:bg-success-alpha12 tw:text-success-dark tw:dark:bg-success-alpha12 tw:dark:text-success-light',
};

export const SeverityPill: FC<SeverityPillProps> = ({ color = 'primary', children, style, className }) => {
  return (
    <span
      className={`tw:inline-flex tw:items-center tw:justify-center tw:rounded-lg tw:px-2 tw:leading-loose tw:text-xs tw:font-medium tw:tracking-wide tw:uppercase tw:whitespace-nowrap tw:shrink-0 ${colorClassMap[color]} ${className || ''}`}
      style={style}
    >
      {children}
    </span>
  );
};
